import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import Circle from 'Common/Components/Circle';
import TinyCircle from 'Common/Components/TinyCircle';
import colors from 'Styles/colors';
import { selectWorkspaces } from 'store/Workspace/selectors';
import { selectWorkspace } from 'store/Pipelines/selectors';
import { setTarget } from 'store/Pipelines/actions';
import { isEmpty } from 'lodash';
import { standardDropdownStyleUnCapitalize } from 'Common/styles/style';
import Step from '../Step';
import {
  Wrapper, Header, StepContainer,
  HeaderContainer, Title, Description, SelectTarget
} from './styled';
import sortArrayByName from 'Common/Functions/sortArrayByName';
import { Dropdown } from 'Common/Components/Inputs';
import { ThemeContext } from 'Context';

const Target = () => {
  const dispatch = useDispatch();
  const workspaces = useSelector((state) => selectWorkspaces(state));
  const activeWorkspaces = workspaces && workspaces.filter((ws) => ws.active);
  const workspacesOptions = !isEmpty(activeWorkspaces)
    ? sortArrayByName(activeWorkspaces.map((el) => ({ name: el.name, desc: el.name })))
    : [];
  workspacesOptions.unshift({ name: '(None)', desc: '(None)' });
  const value = useSelector((state) => selectWorkspace(state));
  const bigCircle = <Circle color={ colors.blueGrey } />;
  const smallCircle = <TinyCircle color={ colors.blueGrey } />;
  const intl = useIntl();

  const options = !isEmpty(workspaces)
    ? workspaces.map((el) => ({ value: el.name, label: el.name }))
    : [];

  const handleChange = (selectedOption) => {
    dispatch(setTarget(selectedOption.value));
  };

  const { themeStyles } = useContext(ThemeContext);

  return (
    <Wrapper>
      <Header>
        <StepContainer>
          <Step icon={ bigCircle } select />
        </StepContainer>
        <HeaderContainer>
          <Title>{ intl.formatMessage({ id: 'pipelines.detail.target.title' }) }</Title>
          <Description>{ intl.formatMessage({ id: 'pipelines.detail.target.description' }) }</Description>
        </HeaderContainer>
      </Header>
      <SelectTarget>
        <StepContainer>
          <Step icon={ smallCircle } last select />
        </StepContainer>
        <Dropdown
          placeholder="Select Target"
          style={ standardDropdownStyleUnCapitalize(themeStyles) }
          options={ options }
          onChange={ handleChange }
          value={ options.find((option) => option.value === value) }
        />
      </SelectTarget>
    </Wrapper>
  );
};
export default Target;
